import 'simplelightbox/dist/simple-lightbox.jquery.min';
import 'slick-carousel/slick/slick';
import 'slick-lightbox-latest/dist/slick-lightbox.min';
import gtag_event from './gtag-init';
import './virtual-submission';
import {otp_init} from '../global/otp';
import '../global/pseudochat';
import {whatsapp_validation_form, check_telesales_valid, get_enquiry_count, increment_enquiry_count, should_require_otp, clean_phone_number} from '../global/validation-form';
import {insert_leads_to_db} from '../global/leads-submission';

export default {
  init() {
    // JavaScript to be fired on the page template
    jQuery(function ($) {
      var current_wa_button_clicked_position = null;
      var siteNavigation = $('.page-template-menu ul.menu');
      var process_submit = false;
      let is_telesales_valid = null;
      const MICROSITE_SUPERLEADS_ID = $('#nndc-footer__superleads-id').val();

      siteNavigation.find( 'a' ).on( 'focus blur', function() {
        $( this ).parents( 'li' ).toggleClass( 'focus' );
      });

      //sticky header
      // Transition effect for navbar
      var sticky_class = 'nav.site-header.sticky-top';
      $(window).scroll(function() {
        // checks if window is scrolled more than 300px, adds/removes solid class
        if ( $(this).scrollTop() > 300 ) {
          $(sticky_class).addClass('solid');
        } else {
          $(sticky_class).removeClass('solid');
        }
      });

      // whatsapp-form action --start
      var microsite_whatsapp_modal = '#whatsapp-form-modal';
      var form_class = 'form.whatsapp-form';
      var form_target = '';
      var number_field = $(form_class + ' input[name="whatsapp_number"]');
      var name_field = $(form_class + ' input[name="name"]');
      var alert_field = $(form_class + ' .message-failed');

      function submit_whatsapp_form(data) {
        if (data == -1 || data == '') {
          alert_field.text('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.').show();
          return;
        }

        if(data.success) {
          // submit success
          $(form_target + ' [name=submit_status]').val('1').trigger('change');

          // send GA tracking
          gtag_event('Whatsapp Submission', current_wa_button_clicked_position);

          if ( $(form_target + ' [name="is_download_brochure"]').val() == 1 ) {
            do_download_brochure();
          } else {
            redirect_submit_whatsapp_form();
          }
        } else {
          $(form_target + ' .message-success').hide();
          $(form_target + ' .message-failed').html('<p>' + data.data.message + '</p>').show();
        }
      }

      function redirect_submit_whatsapp_form() {
        var project_name = $(form_target + ' [name=project_name]').val();
        var telesales_number = $(form_target + ' [name=telesales_number]').val();
        const superleadsText = ` (ID: ${MICROSITE_SUPERLEADS_ID})`;

        $(form_target + ' .modal-body label').hide();
        $(form_target + ' .modal-body input').hide();
        $(form_target + ' .modal-body button').hide();
        $(form_target + ' .message-success').show();

        setTimeout(function() {
          location.href = whatsapp_base_url()+'/send?text=Saya%20ingin%20bertanya%20mengenai%20info%20' + encodeURIComponent(project_name) + encodeURIComponent(superleadsText) + '&phone=' + telesales_number;
        }, 2000); // 2 second
      }

      function whatsapp_base_url() {
        if( is_mobile() ) {
          return 'https://api.whatsapp.com';
        }
  
        return 'https://api.whatsapp.com';
      }

      function is_mobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          return true;
        }else{
          return false;
        }
      }

      function do_download_brochure() {
        $(microsite_whatsapp_modal).modal('hide');

        let _url = $(form_class + ' [name="download_brochure_url"]').val();
        let _url_decode = atob( _url );
        
        window.open( _url_decode, '_blank' ).focus();
        window.location.reload();
      }

      $(form_class).submit(function (e) {
        e.preventDefault();
        var frm = $(this);
        var btn_submit = form_class + ' [type="submit"]';
        gtag_event('Leads form button clicked', current_wa_button_clicked_position+'-not-validated');

        form_target = '#' + frm.attr('id');

        number_field = $(form_target + ' input[name="whatsapp_number"]');
        name_field = $(form_target + ' input[name="name"]');
        alert_field = $(form_target + ' .message-failed');

        let leads_name = name_field.val();
        let leads_number = number_field.val();
        let leads_form = {
          'name': leads_name,
          'number': leads_number,
          'number_field': number_field,
          'alert_field': alert_field,
        };

        if (whatsapp_validation_form(leads_form) == false) {
          return false;
        }

        // Track enquiry count and conditionally require OTP every 3rd enquiry
        const cleanedNumber = clean_phone_number(leads_number);
        const nextEnquiryCount = get_enquiry_count(cleanedNumber) + 1;
        
        // Only call OTP on 1st, 3rd, 6th, 9th... enquiries
        if (should_require_otp(nextEnquiryCount)) {
          console.info('Enquiry count for ' + cleanedNumber + ': ' + nextEnquiryCount + '. OTP validation required.');
          if (otp_init(form_class, e, leads_number, btn_submit) === false) {
            return false;
          }
        }

        if (true === process_submit) {
          alert('Mohon ditunggu, data anda sedang diproses');
          return;
        }

        // Increment enquiry count after submission
        const newCount = increment_enquiry_count(cleanedNumber);
        
        // Clear otp_validated cookie if next enquiry will require OTP validation
        const nextEnquiry = newCount + 1;
        if (should_require_otp(nextEnquiry)) {
          document.cookie = 'otp_validated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }

        gtag_event('Leads form button clicked', current_wa_button_clicked_position+'-validated');

        let data_form = frm.serialize() + '&current_url=' + encodeURIComponent(window.location.href);

        // insert leads data to DB
        insert_leads_to_db(frm);

        $.ajax({
          type: frm.attr('method'),
          url: frm.attr('action'),
          data: data_form,
          beforeSend: function() {
            $(form_target + ' .message-text').hide();
            $(form_target + ' .loader').show();
            $(btn_submit).prop('disabled', true);
            process_submit = true;
          },
          success: function (data) {
            $(form_target + ' .loader').hide();
            submit_whatsapp_form(data);
            $(btn_submit).prop('disabled', false);
            process_submit = false;
          },
          error: function (data) {
            console.log('An error occurred.');
            console.log(data);
            $(btn_submit).prop('disabled', false);
            process_submit = false;
          },
        });

        form_class = '.whatsapp-form';
      });
      // whatsapp-form action --end

      // image gallery
      let i;
      let elementLightBox;
      for (i = 1; i <= 10; i++) {
        elementLightBox = $('.simple-lightbox-' + i + ' a');
        if (elementLightBox.length) {
          elementLightBox.simpleLightbox();
        }
      }

      // play video on modal
      var videoSrc;
      var modalVideoPlayerElm = '#modalVideoPlayer';
      var modalVideoIframeElm = '#modalVideoIframe';
      var imageName;

      $('.play-video-on-modal').click(function () {
          videoSrc = $(this).data( 'video-src' );
          imageName = $(this).data( 'image' );
          $(modalVideoIframeElm).attr( 'src', videoSrc + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0' );
          gtag_event('Button Video Clicked', imageName);
      });

      // stop playing the youtube video when I close the modal
      $(modalVideoPlayerElm).on('hide.bs.modal', function () {
        $(modalVideoIframeElm).attr('src', videoSrc);
      });

      // load google map on click image (Elementor)
      function elementorLoadGmap() {
        if (! $('body').has('template-microsite-three')) {
          return false;
        }

        let mapImg = $('.project-map img');
        let mapImgContainer = $('.project-map .elementor-image');
        let mapInputIframe = $('#gmap-iframe');

        if (! mapImg.length || ! mapImgContainer.length || ! mapInputIframe.length) {
          return false;
        }

        mapImg.click(function(){
          mapImgContainer.removeClass('elementor-image').addClass('elementor-custom-embed');
          let gmap_iframe = mapInputIframe.val();
          $('.project-map .elementor-custom-embed').html(gmap_iframe);
          // send GA tracking
          gtag_event('Map Clicked', null);
        });
      }

      function pageTemplateLoadGmap() {
        let mapContainerClass = '.project-map';
        let mapImgElm = $(mapContainerClass + ' img');
        let mapInputIframeElm = $(mapContainerClass + ' input[type="hidden"]');

        if (! mapImgElm.length || ! mapInputIframeElm.length) {
          return false;
        }

        mapImgElm.click(function(){
          $(mapContainerClass).html( mapInputIframeElm.val() );
          // send GA tracking
          gtag_event('Map Clicked', null);
        });
      }

      elementorLoadGmap();
      pageTemplateLoadGmap();

      // ------------------------------------------ <!-- btn show more or less in cluster description
      let descLines = 7; //Choose how many lines you would like to initially show
      //let descButtonSpacing = 7; //Choose Button Spacing
      //let descButtonSide = 'right'; //Choose the Side the Button will display on: 'right' or 'left'
      let descAnimationSpeed = 500; //Choose Animation Speed (Milliseconds)
      let maxHeight = 160;

      let descLineHeight = $('.col-desc').css('line-height');
      if (descLineHeight != undefined) {
        descLineHeight = descLineHeight.replace('px', '');
      }

      let descStartHeight = descLineHeight * descLines;

      function initUnitTypeHeight() {
        $('.unit-type .row-desc').each(function() {
          if ($(this).height() > maxHeight) {
            $(this).css({'height' : descStartHeight });
          }
        });

        $('.unit-info').each(function() {
          $(this).find('.btn-more').hide();
          $(this).find('.btn-less').hide();

          if ($(this).find('.col-desc').height() > $(this).find('.row-desc').height()) {
            $(this).find('.btn-more').show();
          }
        });
      }
      initUnitTypeHeight();

      $('.nav-tabs .nav-item .nav-link[id^=tab]').click(function () {
        setTimeout(initUnitTypeHeight, 500);
      });

      $('.btn-more').on('click', function() {
        let unitId = $(this).data('current-unit-id');
        let newHeight = $('#col-desc-' + unitId).height();
        $('#row-desc-' + unitId).animate({'height' : newHeight }, descAnimationSpeed );
        $(this).hide().siblings('.btn-less').show();
      });

      $('.btn-less').on('click', function() {
        let unitId = $(this).data('current-unit-id');
        // var h = $(this).parent('div.container').find('div.text').height();
        $('#row-desc-' + unitId).animate({'height' : descStartHeight }, descAnimationSpeed );
        $(this).hide().siblings('.btn-more').show();
      });
      // ------------------------------------------ btn show more or less in cluster description --!>

      $('#cluster-tab-content .btn-more-cluster').on('click', function () {
        let unit_class = $(this).data('unit-class');
        let unit_class_changed = '.' + unit_class + ':gt(1)';
        let unit_show = $(this).data('unit-show');
        let class_hide = 'd-none';

        console.log(unit_class, $(unit_class_changed), unit_show, class_hide);

        if (unit_show == 0) {
          $(unit_class_changed).removeClass(class_hide);
        } else {
          $(unit_class_changed).addClass(class_hide);
        }

        s_cluster_change_btn_more($(this));
      });

      function s_cluster_change_btn_more(btn) {
        if (btn.data('unit-show') == 0) {
          btn.data('unit-show', 1);
          btn.text('Lihat lebih sedikit');

          // event track
          gtag_event('Cluster Button Clicked', 'Show More Unit');
        } else {
          btn.data('unit-show', 0);
          btn.text('Lihat lebih banyak');

          // event track
          gtag_event('Cluster Button Clicked', 'Show Less Unit');
        }
      }

      function change_wa_form(selector) {
        let _title = 'Silakan isi nomor Whatsapp Anda untuk memulai percakapan dengan sales konsultan kami.';
        let _is_download_brochure = 0;
        let _download_brochure_url = '';
        let _lead_type_id = 1;
        let _lead_type_name = 'Whatsapp';

        let _btn_submit_selector = $(form_class + ' [type="submit"]');
        let _submit_text = _btn_submit_selector.data('wa-text');
        let _btn_submit = _submit_text != '' ? _submit_text : 'Chat Sekarang';
        let _submit_class = _btn_submit_selector.data('wa-class');
        _btn_submit_selector.removeClass('btn-blue');
        _btn_submit_selector.addClass(_submit_class);

        if ( selector.hasClass('btn-download-brochure') ) {
          _title = 'Silakan isi form di bawah ini terlebih dahulu untuk download brosur.';
          _is_download_brochure = 1;
          _download_brochure_url = selector.attr('href');
          _lead_type_id = 3;
          _lead_type_name = 'Brochure';

          _submit_text = _btn_submit_selector.data('download-text');
          _btn_submit = _submit_text != '' ? _submit_text : 'Download';
          _submit_class = _btn_submit_selector.data('download-class');
          _btn_submit_selector.removeClass('btn-success');
          _btn_submit_selector.addClass(_submit_class);
        }

        // clear form
        name_field.val('');
        number_field.val('');

        $(form_class + ' .modal-title').text( _title );
        _btn_submit_selector.html( _btn_submit );
        $(form_class + ' [name="is_download_brochure"]').val( _is_download_brochure );
        $(form_class + ' [name="download_brochure_url"]').val( _download_brochure_url );
        $(form_class + ' [name="lead_type_id"]').val( _lead_type_id );
        $(form_class + ' [name="lead_type_name"]').val( _lead_type_name );
        $(form_class + ' [type="submit"]').prop( 'disabled', false );
      }

      // visit
      setTimeout(function() {
        gtag_event('Visit', 'Visit');
      }, 1500);

      // whatsapp button
      $('.btn-whatsapp-general:not(.btn-chat-box)').click(function () {
        current_wa_button_clicked_position = $(this).data('position');
        gtag_event('Whatsapp Button Clicked', current_wa_button_clicked_position);
        change_wa_form( $(this) );

        if(is_telesales_valid == null) {
          is_telesales_valid = check_telesales_valid(); // check telesales number validity to avoid cache issue
        }
      });


      $('.btn-whatsapp-general').click(function () {
        // eslint-disable-next-line no-undef
        $.post(global_params.ajax_url, { action: 'refresh_whatsapp_nonce' }, function(response) {
          if (response.success) {
            $('input[name="_wpnonce"]').val(response.data.nonce);
            console.info('refresh_whatsapp_nonce success', response.data.nonce);
          }
        });
      });

      var scrollOneQuarter = null;
      var scrollHalf = null;
      var scrollThreeQuarter = null;
      var scrollFull = null;
      var vertical_scroll_event_name = 'Vertical Scroll';

      // vertical scroll
      $(window).scroll(function() {
        // calculate the percentage the user has scrolled down the page
        let scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());

        if (scrollOneQuarter == null && scrollPercent >= 25 && scrollPercent < 50) {
          gtag_event(vertical_scroll_event_name, 25, 25);
          scrollOneQuarter = 1;
        }

        if (scrollHalf == null && scrollPercent >= 50 && scrollPercent < 75) {
          gtag_event(vertical_scroll_event_name, 50, 50);
          scrollHalf = 1;
        }

        if (scrollThreeQuarter == null && scrollPercent >= 75 && scrollPercent < 95) {
          gtag_event(vertical_scroll_event_name, 75, 75);
          scrollThreeQuarter = 1;
        }

        if (scrollFull == null && scrollPercent >= 95) {
          gtag_event(vertical_scroll_event_name, 100, 100);
          scrollFull = 1;
        }
      });

      // image clicked event
      let imageDetails = [
        ['.facility-wrap img', 'Facility Clicked'],
        ['.unit-type img', 'Unit Type Clicked'],
      ];

      $.each(imageDetails, function(key, eventDetails) {
        let element = $(eventDetails[0]);
        let eventName = eventDetails[1];

        if (element.length) {
          element.click(function() {
            let imgSrc = $(this).attr('src');
            let imgNameIndex = imgSrc.lastIndexOf('/') + 1;
            let imgFilename = imgSrc.substr(imgNameIndex);

            gtag_event(eventName, imgFilename);
          });
        }
      });

      // VR or Video clicked event
      let vrVideoWraps = [
        ['.vr-gallery-wrap.type-vr', 'VR Gallery Clicked'],
        ['.vr-gallery-wrap.type-video', 'Video Gallery Clicked'],
      ];

      $.each(vrVideoWraps, function(key, eventDetails) {
        let element = $(eventDetails[0]);
        let eventName = eventDetails[1];
        let imgSrc = $(eventDetails[0] + ' img').attr('src');

        if (element.length) {
          element.click(function() {
            let imgNameIndex = imgSrc.lastIndexOf('/') + 1;
            let imgFilename = imgSrc.substr(imgNameIndex);

            gtag_event(eventName, imgFilename);
          });
        }
      });

      $('#section-vr-gallery .vr-gallery-wrap').click(function() {
        let url = $(this).data('url');
        let html = '';
  
        if ( $(this).hasClass('type-vr') ) {
          html = '<iframe src="' + url + '" height="300" allowfullscreen="" allow="xr-spatial-tracking"></iframe>';
        } else {
          html = url;
        }
  
        $(this).closest('div').removeClass('type-vr').removeClass('type-video').html(html);
      });

      // cluster
      let clusterElement = $('#cluster-tab a');
      if (clusterElement.length) {
        clusterElement.click(function () {
          let tabText = $(this).text();

          gtag_event('Cluster Tab Clicked', $.trim(tabText));
        });
      }

      // btn cluster detail
      let btnClusterElement = $('.unit-type .btn-detail a');
      if (btnClusterElement.length) {
        btnClusterElement.click(function () {
          let url = $(this).attr('href');
          let urlIndex = url.lastIndexOf('/') + 1;
          let urlPath = url.substr(urlIndex);

          gtag_event('Cluster Detail Button Clicked', urlPath);
        });
      }

      let linkArticleDetail = $('.link-article-detail');
      if (linkArticleDetail.length) {
        linkArticleDetail.click(function () {
          gtag_event('Link Article Clicked', $(this).data('link-name'));
        });
      }

      let btnArticleDetail = $('.btn-article-detail');
      if (btnArticleDetail.length) {
        btnArticleDetail.click(function () {
          gtag_event('Button Article Clicked', $(this).data('link-name'));
        });
      }

      // KPR Tracker
      let eventTracks = [
        ['.kpr-widget .btn-kpr-submit-now', 'Button KPR Submit Now Clicked', 'Widget'],
        ['.kpr-widget .btn-kpr-submit', 'Button KPR Submit Clicked', 'Widget'],
        ['.kpr-widget .btn-kpr-calculate', 'Button KPR Calculate Clicked', 'Widget'],
        ['.kpr-content .btn-kpr-calculate', 'Button KPR Calculate Clicked', 'Single Page'],
        ['.kpr-content .btn-kpr-submit', 'Button KPR Submit Clicked', 'Single Page'],
        ['.kpr-content .btn-kpr-submit-bank__bni', 'Button KPR Submit Bank Clicked', 'BNI'],
        ['.kpr-content .btn-kpr-submit-bank__uob', 'Button KPR Submit Bank Clicked', 'UOB'],
        ['.kpr-content .btn-kpr-submit-bank__nisp', 'Button KPR Submit Bank Clicked', 'NISP'],
        ['.kpr-content .steps #form-total-t-0', 'Button Step Icon Clicked', 'Personal Data'],
        ['.kpr-content .steps #form-total-t-1', 'Button Step Icon Clicked', 'Income'],
        ['.kpr-content .steps #form-total-t-2', 'Button Step Icon Clicked', 'Property Details'],
      ];

      // KPR Submission
      function getKprSubmissionCurrentStep() {
        let currentStepId = $('.kpr-content section[id^="form-total-p"]:visible').attr('id');
        let currentIds = currentStepId.split('-');
        return Number( currentIds[currentIds.length - 1] ) + 1;
      }

      let eventSteps = [
        ['.kpr-content .actions a[href="#next"]', 'Button Next Step Clicked'],
        ['.kpr-content .actions a[href="#previous"]', 'Button Previous Step Clicked'],
        ['.kpr-content .actions a[href="#finish"]', 'Button Finish Step Clicked'],
      ];

      setTimeout(function () {
        $.each(eventTracks, function(key, eventDetails) {
          let element = $(eventDetails[0]);
          let eventName = eventDetails[1];
          let eventLabel = eventDetails[2];

          if (element.length) {
            element.click(function(e) {
              if (e.originalEvent !== undefined) {
                // real click from user
                gtag_event(eventName, eventLabel);
              }
            });
          }
        });

        $.each(eventSteps, function(key, eventDetails) {
          let element = $(eventDetails[0]);
          let eventName = eventDetails[1];
          let currentStep = 1;

          if (element.length) {
            element.click(function(e) {
              if (e.originalEvent !== undefined) {
                currentStep = getKprSubmissionCurrentStep();
                gtag_event(eventName, 'Current Step ' + currentStep);
              }
            });
          }
        });
      }, 3000);
      // ------------------------------------------ GA Tracking --!>

      $('.unit-detail-link').on('click', function () {
        clone_unit_type($(this).data('unit-id'));
        // event track
        gtag_event('Unit Type More Clicked', $(this).data('unit-name'));
      });

      function clone_unit_type(unit_id) {
        let unit_title_elm = '#unit-info-' + unit_id + ' .unit-title';
        let unit_type_elm = '#unit-type-' + unit_id;
        let unit_detail_elm = '#unit-detail-wrap-' + unit_id;
        let container_elm = '#unit-type-modal .unit-type';
        let new_unit_type_id = 'unit-type-clone';
        let new_unit_type_detail_id = 'unit-type-detail-clone';

        // clone content
        $(container_elm).text('');
        $('#unit-type-modal-label').html('<h4>' + $(unit_title_elm).text() + '</h4>');
        $(unit_type_elm).clone().attr('id', new_unit_type_id).appendTo($(container_elm));
        $(unit_detail_elm).clone().attr('id', new_unit_type_detail_id).appendTo($(container_elm));

        // change id
        $('#' + new_unit_type_id + ' .carousel-control-prev').attr('href', '#' + new_unit_type_id);
        $('#' + new_unit_type_id + ' .carousel-control-next').attr('href', '#' + new_unit_type_id);
        $('#' + new_unit_type_id + ' .carousel-indicators li').attr('data-target', '#' + new_unit_type_id);
        $('#' + new_unit_type_id + ' .carousel-item').removeClass('simple-lightbox-2');
        /*
        $('#' + new_unit_type_id + ' .carousel-item').addClass('simple-lightbox-modal-2');
        $('.simple-lightbox-modal-2 a').simpleLightbox();
        */
        $('#' + new_unit_type_detail_id + ' .description').removeClass('d-none');

        $('#' + new_unit_type_id + ' .carousel-item a').on('click', function () {
          return false;
        });

        $('#unit-type-modal').modal('show');
      }

      $('.virtual-tour-slides').not('.slick-initialized').slick({
        mobileFirst: true,
        infinite: true,
        arrows: true,
        dots: true,
        lazyLoad: true,
        prevArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-prev"><svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.666646 13.3797C0.666646 13.0172 0.822839 12.6546 1.13523 12.3781L15.0698 0.0463866L17.3333 2.04956L4.53053 13.3797L17.3333 24.7099L15.0698 26.7131L1.13523 14.3813C0.822839 14.1049 0.666646 13.7423 0.666646 13.3797Z" fill="white"/></svg></button>',
        nextArrow: '<button type="button" class="btn btn-sm btn-light btn-arrow btn-next"><svg width="18" height="27" viewBox="0 0 18 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.3334 13.3797C17.3334 13.0172 17.1772 12.6546 16.8648 12.3781L2.93022 0.0463866L0.666687 2.04956L13.4695 13.3797L0.666688 24.7099L2.93022 26.7131L16.8648 14.3813C17.1772 14.1049 17.3334 13.7423 17.3334 13.3797Z" fill="white"/></svg></button>',
        slidesPerRow: 1,
      });

		$('section.faq .card-header').on('click', function () {
			console.info('clicked');
			gtag_event('FAQ Clicked', $(this).attr('id'));
		});
	
		$('.unit-type-wrap .btn-more').on('click', function () {
			gtag_event('Unit Type More Clicked', $(this).data('unit-name'));
		});
	
		$('.unit-type-wrap .btn-view-detail').on('click', function () {
			gtag_event('Detail Unit Button Clicked', $(this).data('unit-name'));
		});
    });
  },
  finalize() {
    // JavaScript to be fired on the page template, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/page-template.js